import React, { Component } from 'react';
import './App.css';
import Login from "./login";
import Services from "./Services/Services"
import Data from "./Data/Data.jsx"
import Main from "./Views/Main.jsx"
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Util from './Util/Util.jsx'
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './Theme';

class App extends Component {
  data;
  services;

  constructor() {
    super();  

    this.state = {
      errorMessage: "",
      isMain: false
    }

    this.data = new Data();
    this.services = new Services(this.data);
    this.data.Login.GetTokenCallback = this.getTokenCallback.bind(this);
    this.data.Service.GetReportCallback = this.getReportCallback.bind(this);
  }

  getReportCallback(data, isCSV){
    let util = new Util();
    if(isCSV){
      util.showFileCSV(data,"Report.csv"); 
    }else{
      util.showFilePDF(data,"Report.pdf"); 
    }
  }

  // Read a page's GET URL variables and return them as an associative array.
getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

removeQueryString(){
  var uri = window.location.toString();
	if (uri.indexOf("?") > 0) {
	    var clean_uri = uri.substring(0, uri.indexOf("?"));
	    window.history.replaceState({}, document.title, clean_uri);
  }
  
  // Change FAV Icon after return from Office 365
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'https://www.abacusnext.com/sites/default/files/favicon-128.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
}

getTokenCallback(token, error){
  if(error != null){
    this.data.Login.ErrorCallback(error);
  }
  else
  {
    this.setState({isMain: true});
  }
}
  
  render() {
    let code = this.getUrlVars()["code"];
    if(code!==undefined){
      this.services.getAPXToken(code, this.data)
    }
    
    if(code !== undefined){
      this.removeQueryString();
      this.data.Login.IsCodePresent = true;
    }

    return (
      <div className="App">
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {this.state.isMain ? <Main data={this.data}></Main> : <Login data={this.data}></Login>}
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default App;